import { createApp } from 'vue'
import App from './App.vue'
import router from './router/'

import { Button } from 'ant-design-vue';
import { Checkbox } from 'ant-design-vue';
import { Input } from 'ant-design-vue';
import { Icon } from 'ant-design-vue';
import { Carousel } from 'ant-design-vue';
// import 'ant-design-vue/dist/antd.css'
import 'ant-design-vue/lib/button/style';
import 'ant-design-vue/lib/checkbox/style';
import 'ant-design-vue/lib/input/style';
import 'ant-design-vue/lib/icon/style';
import 'ant-design-vue/lib/carousel/style';

const app = createApp(App);

/* 会自动注册 Button 下的子组件, 例如 Button.Group */
app.use(Button);
app.use(Checkbox);
app.use(Input);
app.use(Icon);
app.use(Carousel);
app.use(router).mount('#app')
